import React from "react";
import { Fragment } from 'react';
import { useDispatch } from "react-redux";

import QrReader from "react-qr-reader";
import "../../Css/QR_Reader.css";

const QR_Reader = (props) => {
  const { setPopupData, setProductData } = props;
  const handleScan = (data) => {
    try {
      if (data && data != null) {
        setPopupData({ show: false });
        if (data.includes("\\n")) {
          data = data.split("\\n")[0];
        }
        else if (data.includes("\n")) {
          data = data.split("\n")[0];
        }
        if (data.includes("\r")) {
          data = data.replace("\r", "");
        }
        else if (data.includes("\\r")) {
          data = data.replace("\\r", "");
        }
        const dataArray = data.split(",");
        const finalObj = {};
        dataArray.forEach(d => finalObj[d.split(":")[0]] = d.split(":")[1])
        setProductData(finalObj);
      }
    }
    catch (e) {
      console.log("[QRCODE_SCAN]", e);
    }

  }
  const handleError = err => {
    console.error("[QR_SCAN_ERROR]", err)
  }
  return (
    <Fragment>
      <div className="camStyle">
        <QrReader
          delay={500}
          onError={handleError}
          onScan={handleScan}
          facingMode="environment"

        />
      </div>
      <button type="button" className="btn btn-danger" style={{ fontSize: "10px", marginTop: "5px" }} onClick={() => setPopupData({ show: false })}>انصراف</button>
    </Fragment>

  )
}
export default QR_Reader;